import styled from 'styled-components';
import { removeScrollbar } from '@/styles/helpers';

export const Container = styled.div`
  ${removeScrollbar()}

  display: flex;
  gap: 10px;
  overflow-x: auto;
  margin-top: 20px;
`;
